import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      "&.Mui-disabled": {
        "& .MuiTypography-root, .MuiSvgIcon-root": {
          color: Colors.GREY350,
        },
      },
    },
  },
};
